import { ref, computed, onMounted, onUnmounted, getCurrentInstance } from 'vue';

/**
 * Comportamiento de dropdown anclado para los widgets del header admin.
 * - `hover: true` (carrito): abre al pasar el mouse (paridad con el widget
 *   legacy de taquilla) y además queda "fijado" con click (también en touch).
 * - `hover: false` (notificaciones): solo click, como el b-dropdown anterior.
 * Cierra con click afuera o Escape.
 *
 * @param {import('vue').Ref<HTMLElement|null>} rootRef — raíz del widget
 * @param {{hover?: boolean}} [options]
 */
export function useHeaderDropdown(rootRef, options = {}) {
    const hover = options.hover !== false;
    const pinned = ref(false);
    const hovered = ref(false);
    const open = computed(() => pinned.value || (hover && hovered.value));

    function toggle() {
        pinned.value = !pinned.value;
    }

    function close() {
        pinned.value = false;
        hovered.value = false;
    }

    function onMouseEnter() {
        if (hover) hovered.value = true;
    }

    function onMouseLeave() {
        hovered.value = false;
    }

    function handleDocumentClick(event) {
        const root = rootRef && rootRef.value;
        if (!root) return;
        if (!root.contains(event.target)) close();
    }

    function handleKeydown(event) {
        if (event.key === 'Escape') close();
    }

    if (getCurrentInstance()) {
        onMounted(() => {
            document.addEventListener('click', handleDocumentClick);
            document.addEventListener('keydown', handleKeydown);
        });
        onUnmounted(() => {
            document.removeEventListener('click', handleDocumentClick);
            document.removeEventListener('keydown', handleKeydown);
        });
    }

    return { open, pinned, hovered, toggle, close, onMouseEnter, onMouseLeave };
}
